export default class SubscriptionResult {
    public displayText: string;

    public constructor(obj: any) {
        this.displayText = obj.displayText;
    }
}